import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input, NgZone, OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {DateTimePeriodService} from '../../services/date-time-period.service';
import {
    MatTableDataSource
} from '@angular/material/table';
import {forkJoin, fromEvent, Observable, of, Subject, Subscription} from 'rxjs';
import {ApiService} from '../../services/api/api.service';
import {HeaderDataService} from '../../services/header_data.service';
import {FormDialogService} from '../../services/form-dialog.service';
import {AppScope} from '../../services/app_scope.service';
import {MatSort} from '@angular/material/sort';
import {
    catchError,
    concatMap,
    debounceTime,
    finalize,
    first,
    map,
    skip, switchMap,
    take,
    takeUntil,
    tap
} from 'rxjs/operators';
import * as utils from '../../lib/utils';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Component as WireComponent} from '../../_models/component';
import {ConstantProperty} from '../../_models/constant-property';
import {CachingService} from "../../services/caching.service";
import {CustomEventsService} from "../../services/custom-events.service";
import {SearchQueryOptions} from "../../services/api/search-query-options";
import {
    ExportComponentConfig,
    ExporterType
} from "../../forms/component-events-table-form/component-events-table-form.component";
import {ListResponse} from "../../services/api/response-types";
import {ColumnFormats, ColumnFormatsDict, TableUtilsService} from '../../services/table-utils.service';
import {TileDataService} from '../../services/tile_data.service';
import {TilePdfGeneratorService} from '../../services/tile-pdf-generator.service';
import {ConstantPropertyComponentType} from "../../_models/constant-property-component-type";
import {ComponentEventsTableService, ConstantDateFilter} from "./component-events-table.service";
import {DownloadService} from "../../services/csv-download.service";
import {ConditionalFormattingConfig, ConditionalFormattingService} from "../../services/conditional-formatting.service";
import {BaseModel, IDMap, KeyMap, KeyMapMap, ModelID, RESTFilter, ModelWithLimits} from "../../_typing/generic-types";
import {getRelationWithIdFilter, getRelationWithManyIdsFilter} from "../../services/api/filter_utils";
import {LockDataService} from "../../services/lock-data.service";
import {
    ConstantField, ConstantRelationshipAggregationRequest,
    ConstantValue,
    GenericConstantApiResponse,
    GenericConstantData,
    GenericField,
    isConstant
} from "../../_models/api/generic-constant";
import {GenericConstantDataService} from "../../data/generic-constant-data.service";
import {
    getAttributeIds,
    getColumnId,
    getColIds,
    getComponentTypeIds,
    getPropertyIds, getRelatedComponentTypeIds
} from '../custom-events-table/utils';
import {EventConfigColumn} from "../../_typing/config/config-column";
import {ActivatedRoute, Router} from '@angular/router';
import {CalcGraphStatusService, ConstantCalculationsStatusResponse} from "../../services/api/calcGraphStatus.service";
import {
    FilterTableButtonComponent,
    FilterTableButtonConfig
} from "../../components/filter-table-button/filter-table-button.component";
import {NotificationService} from "../../services/notification.service";
import {IDateTimePeriod} from "../../_typing/date-time-period";
import {UserService} from "../../services/user.service";
import {
    LOGIN_LOGO_URL,
    NOTIFICATION_DURATION_MS, RIGHT_LOGO_MMS_URL,
    TABLE_PAGE_SIZE,
    TOOLTIP_SHOW_DELAY
} from "../../shared/globals";
import {FILE_DOWNLOAD_OPTIONS, FileDownloadOption} from "../../_typing/download-filetype";
import {ValidationBuilderService} from "../../services/validation-builder.service";
import {ValidatorRule} from "../../_typing/query-builder";
import {deepCopy, stringDate} from "../../lib/utils";
import {DateTimeInstanceService} from "../../services/date-time-instance.service";
import {ComponentType} from "../../_models/component-type";
import {ComponentTypeDataService, UniqueComponentTypeRelationshipDict} from "../../data/component-type-data.service";
import {ComponentComponent} from "../../_models/component-component";
import {ComponentComponentDataResponse, ComponentDataService} from "../../data/component-data.service";
import {RelationshipApiMappingService} from "../../data/relationship-api-mapping.service";
import {RelMappingResult} from "../../_typing/relationship-api-mapping";
import {camelLabel} from "../../lib/utils";
import {LdsRollerDirective} from "../../directives/lds-roller.directive";
import {UtilsBarComponent} from "../utils-bar/utils.bar.component";
import {OverlayscrollbarsModule} from "overlayscrollbars-ngx";
import {ColumnResizeDirective} from "../../directives/column-resize.directive";
import {
    AuditMixinIndicatorComponent
} from "../../components/audit-mixin/audit-mixin-indicator/audit-mixin-indicator.component";
import {FitContentDirective} from "../../directives/fit-content.directive";
import {DateTimePickerComponent} from "../../date-time/date-time-picker/date-time-picker.component";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {SelectManySearchBaseComponent} from "../../components/select-search-api/many/select-many-search-base.component";
import {RowResizeDirective} from "../../directives/row-resize.directive";
import {PdfFooterComponent} from "./pdf-footer/pdf-footer.component";
import {ComponentsTableComponent} from "./components-table/components-table.component";
import {EventsTableComponent} from "./events-table/events-table.component";
import {
    ComponentPrintoutMenuComponent
} from "../../components/component-printout-menu/component-printout-menu.component";
import {PdfHeaderComponent} from "./pdf-header/pdf-header.component";
import {
    GenericComponentFieldComponent
} from "../../components/generic-component-field/generic-component-field.component";
import {SharedModule} from "../../shared/modules/shared-module.module";
import {COMPONENT_EVENTS_CONFIG} from "../../_typing/config/component-events-table";
import {PdfExportService} from "../../services/pdf-export.service";
import {ClearConstantService} from "../../components/constant-field/clear-constant.service";

@Component({
    selector: 'component-events-table',
    templateUrl: './component-events-table.component.html',
    styleUrls: ['./component-events-table.component.less'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SharedModule,
        LdsRollerDirective,
        UtilsBarComponent,
        FilterTableButtonComponent,
        OverlayscrollbarsModule,
        PdfHeaderComponent,
        ColumnResizeDirective,
        AuditMixinIndicatorComponent,
        FitContentDirective,
        ComponentPrintoutMenuComponent,
        DateTimePickerComponent,
        GenericComponentFieldComponent,
        SelectSearchComponentComponent,
        SelectManySearchBaseComponent,
        EventsTableComponent,
        ComponentsTableComponent,
        RowResizeDirective,
        PdfFooterComponent,
    ],
    providers: [TableUtilsService, PdfExportService, ClearConstantService]
})
export class ComponentEventsTableComponent implements OnInit, OnDestroy {
    expandedElement: any | null = null;
    expandedEvents: any | null = null;
    expandedComponents: any | null = null;
    formats: KeyMap<ColumnFormatsDict> = {};
    buttons: any[] = [];
    columns: string[] = [];
    agg_columns: string[] = [];
    dtp: IDateTimePeriod;
    componentTypes: ComponentType[] = [];
    ctDict: IDMap<ComponentType> = {};
    ctCtDict: UniqueComponentTypeRelationshipDict = {};
    componentComponentTypeMap: Partial<ComponentComponentDataResponse> = {};
    componentComponentDict: IDMap<WireComponent> = {};
    constant_properties: ConstantProperty[] = [];
    cp_dict: IDMap<ConstantProperty> = {};
    cp_class_dict: Record<string, { class: string, message: string }> = {};
    component_type: any;
    components: WireComponent[] = [];
    components_properties: string[] = [];
    /**Related component types and their respective properties**/
    componentTypePropertyMap: IDMap<ModelID[]> = {};
    attribute_cols: string[] = [];
    attribute_cols_set: Set<string> = new Set();
    attribute_cols_name_dict: { [key: string]: string } = {};
    format_dict: ColumnFormatsDict = {};
    rowHeightDict: KeyMap<Partial<ColumnFormats>> = {};
    conditional_dict: KeyMapMap<Partial<ColumnFormats>> = {};
    conditions: ConditionalFormattingConfig[];
    aggregation_row: any = {};
    limits_map: Partial<ModelWithLimits<ConstantPropertyComponentType>> = {};
    /** True once the main render cycle has completed; used to avoid a redundant markForCheck from CPCT callback. */
    private _tableRenderComplete = false;
    selected_cols_dict: Record<string, EventConfigColumn> = {};
    auditMixinDict: KeyMap<KeyMap<BaseModel<WireComponent> & { id: string; type: string; auditItemId?: ModelID }>> = {};
    relComponentAuditdict: KeyMap<KeyMap<BaseModel<WireComponent>>> = {};
    generic_constants: KeyMap<KeyMap<GenericField>> = {};
    dataSource: MatTableDataSource<any>;
    $components: Subscription | null;
    $constant_properties: Subscription | null;
    page_size: number = TABLE_PAGE_SIZE;
    page_size_options: number[] = [10, 20, 50, 100, 200];
    page_index: number = 0;
    component_total;
    loading_next: boolean = false;
    search_by_name: string;
    table_height: string = 'calc(100% - 41px)';
    user_filters: any;
    query_builder_filters: any; // Used to store the part of user_filters that comes from the quick-edit query builder
    filter_string: string = '';
    filter_button_config: FilterTableButtonConfig;
    user_search_selections: string[] = [];
    user_search_fields: { name: string; value: string }[] = [];

    filter_warning: string;
    messages: string[] = [];
    isRenderingPdf: boolean = false;
    constant_property_component_types: ConstantPropertyComponentType[];
    rows_selection_status: { [key: string]: boolean } = {};
    component_state: { [key: string]: { state: 'error' | 'success', message: string } } = {};

    doValidation: boolean;
    doFormatting: boolean;
    autoFormattingIds: ModelID[];
    validationDict: KeyMap<ValidatorRule[]>;

    private sort;
    private readonly onDestroy = new Subject<void>();
    private _calc_updating_message: string = "";
    private _calculationCurrentlyUpdatingSubscription: Subscription;
    private filteredData: Subject<string> = new Subject<string>();
    private rblTriggerInProgress: boolean = false;
    /** True while a bulk file download request is in flight (POST → job poll). */
    private isDownloading: boolean = false;
    private hasAutoLinkingRules: boolean = false;
    private tableHeightTimeoutId: ReturnType<typeof setTimeout> | null = null;
    public can_unlock = false;
    tooltipShowDelay = TOOLTIP_SHOW_DELAY;

    // endregion
    // region Decorators
    // eslint-disable-next-line @typescript-eslint/member-ordering
    @Input() config: COMPONENT_EVENTS_CONFIG;
    @Input() is_tile: boolean;

    @Output() needToEdit: EventEmitter<string> = new EventEmitter();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('component_events_table') component_events_table: ElementRef;
    @ViewChild('top_scroll') top_scroll: ElementRef;
    @ViewChild('utils_bar') utils_bar;

    @ViewChild(MatSort) set content(content: ElementRef) {
        this.sort = content;
        if (this.sort && this.dataSource) {
            this.dataSource.sort = this.sort;
        }
    }

    constructor(private api: ApiService,
                private dateTimePeriodService: DateTimePeriodService,
                private dateInst: DateTimeInstanceService,
                public router: Router,
                private activatedRoute: ActivatedRoute,
                private headerData: HeaderDataService,
                private changeDetectorRef: ChangeDetectorRef,
                private formDialogService: FormDialogService,
                private appScope: AppScope,
                private notification: NotificationService,
                private clearConstantService: ClearConstantService,
                private cache: CachingService,
                public eventsService: CustomEventsService,
                public componentEventsTableService: ComponentEventsTableService,
                public tableUtils: TableUtilsService,
                public tileData: TileDataService,
                public renderer: Renderer2,
                public tilePdfGeneratorService: TilePdfGeneratorService,
                private csvExporter: DownloadService,
                private conditionalService: ConditionalFormattingService,
                private lockDataService: LockDataService,
                private genericConstantData: GenericConstantDataService,
                private calcGraphStatusService: CalcGraphStatusService,
                private userService: UserService,
                private validationService: ValidationBuilderService,
                private componentTypeDataService: ComponentTypeDataService,
                private componentDataService: ComponentDataService,
                private relationshipMappingService: RelationshipApiMappingService,
                private pdfExport: PdfExportService,
                private ngZone: NgZone,
    ) {
    }

    ngOnInit(): void {
        this.eventsService.event_state = {};
        this.dataSource = new MatTableDataSource<any>();
        this.dataSource.paginator = this.paginator;
        this.cache.clearCache(); // Make sure the cache is cleared for events-table when form is updated
        if (this.config.component) {
            if (!this.config.component.relationships.component_type?.data?.id) {
                this.notification.openError('This Component does not have a Component Type.');
                return;
            }
            this.component_type = this.config.component.relationships.component_type.data;
        } else {
            this.component_type = this.config.selected_component_type;
        }
        if (!this.component_type) {
            this.tileData.noTileData.next({message: 'This table has not been configured.'});
            return;
        }
        ComponentEventsTableService.ensureIncludeNullConstantDatesDefault(this.config);
        if (this.config.page_size && !isNaN(this.config.page_size)) {
            this.page_size = this.config.page_size;
            if (!this.page_size_options.includes(this.page_size)) {
                this.page_size_options.push(this.page_size);
            }
        }
        if (this.config.selected_cols) {
            this.config.selected_cols.component_type.forEach((item, index) => {
                this.selected_cols_dict[getColumnId(item)] = {...item, index};
            });
        }

        this.validationDict = this.validationService.getValidationDict(this.config.validation, this.selected_cols_dict);
        this.conditions = this.config.conditional_formats || [];

        if (this.config.show_aggregations) {
            this.filteredData.pipe(debounceTime(1000)).subscribe(() => {
                if (this.columns && this.dataSource.filteredData) {
                    this.addAggregationRow();
                    this.changeDetectorRef.markForCheck();
                }
            });
        }

        this.dateTimePeriodService.dtpInitialisedPromise.promise.then((dtp) => {
            this.dtp = this.dateInst.dtp;
            if (!this.config.search_by_name) {
                this.refreshComponents();
            }
        });
        // skip(1) skips the initial emission that fires synchronously during bootstrap,
        // which would cause a duplicate refreshComponents() alongside dtpInitialisedPromise.
        this.dateInst.dateTimePeriodRefreshed$.pipe(skip(1), takeUntil(this.onDestroy)).subscribe((dtp) => {
            this.dtp = dtp;
            this.cache.clearCache();
            this.refreshComponents();
        });

        if (this.tileData?.save_content) {
            this.tileData.save_content.pipe(takeUntil(this.onDestroy)).subscribe(event => {
                if (!this.tileData.tile) {
                    return;
                }
                this.tileData.tile.attributes.parameters.selected_cols.component_type =
                    this.tableUtils.updateColumnFormats(this.config.selected_cols.component_type, this.format_dict);

                Object.keys(this.rowHeightDict)?.forEach(key => {
                    if (this.rowHeightDict[key].height) {
                        this.config[key] = this.rowHeightDict[key].height;
                    }
                })
                this.tableUtils.emitSaveTile(this.tileData);
            });
        }
        this.ngZone.runOutsideAngular(() => {
            fromEvent(window, 'resize').pipe(debounceTime(250), takeUntil(this.onDestroy))
                .subscribe(() => {
                    this.ngZone.run(() => this.setTableHeight());
                });
        });

        this.componentEventsTableService.$componentSaved.pipe(takeUntil(this.onDestroy))
            .subscribe((data: { component: WireComponent; custom_constant_dict: KeyMap<ConstantValue> }) => {
                this.updateComponentValues(data.component, data.custom_constant_dict);
            });
        this.componentEventsTableService.$refreshComponentEventsTable.pipe(takeUntil(this.onDestroy))
            .subscribe(() => this.refreshComponents());

        this.componentEventsTableService.jobComplete$.pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
                this.isDownloading = false;
                this.setButtons();
                this.changeDetectorRef.markForCheck();
            });

        this.can_unlock = this.userService.canUnlockData();

        if (this.component_type?.id && this.userService.canRunAutoLinking()) {
            this.api.getComponentTypeLinks({component_type_id: this.component_type.id}).pipe(
                takeUntil(this.onDestroy)
            ).subscribe({
                next: response => {
                    const links = response?.links || [];
                    this.hasAutoLinkingRules = links.some(l => !!l.automatic_linking_rule);
                    this.setButtons();
                },
                error: () => {
                }
            });
        }
    }

    updateComponentValues(component: WireComponent, custom_constant_dict: KeyMap<ConstantValue>) {
        if (this.components.findIndex(c => c.id === component.id) < 0) {
            return;
        }
        Object.keys(custom_constant_dict).forEach(cc => {
            if (this.generic_constants[component.id][cc] && isConstant(this.generic_constants[component.id][cc])) {
                (this.generic_constants[component.id][cc] as ConstantField).value = custom_constant_dict[cc];
            }
        });
        this.updateConditionalColumnFormats();
        this.changeDetectorRef.markForCheck();
    }

    /** Extracts the display name from a component object for use as a stringFunction in select-many-search-component.
     * Avoids a _fetchName API call when value objects already contain the full component attributes. */
    readonly getComponentName = (item: WireComponent): string => item?.attributes?.name ?? null;

    ngAfterViewInit() {
        this.setButtons();
        this.checkComponentConstantCalculationsStatusPoll();
    }

    refreshComponents() {
        this.$components = utils.refreshSubscription(this.$components);
        let $component_obs;
        this.tileData.noTileData.next('');

        if (this.config.component) {
            this.components = [this.config.component];
            $component_obs = this.getComponentProperties();
        } else {
            $component_obs = forkJoin([this.getComponents(), this.getComponentProperties(), this.getComponentTypeComponentTypes()]);
        }

        this.$components = $component_obs.pipe(takeUntil(this.onDestroy),
            concatMap(() => {
                this.filter_warning = '';
                this.setButtons();
                this.doQueryWarning();
                if (!this.components || this.components.length <= 0) {
                    // Header still renders (createComponentsTable runs below on this empty emission) and
                    // the empty dataSource triggers the in-table *matNoDataRow, so no floating overlay.
                    this.loading_next = false;
                    this.changeDetectorRef.markForCheck();
                    return of([]);
                }
                this.autoFormattingIds = Array.from(new Set(
                    this.conditions.flatMap(condition =>
                        condition.comparer === 'auto' && Array.isArray(condition.columns)
                            ? condition.columns.filter(col => col.type === 'constant_property').map(col => col.id)
                            : []
                    )
                ));
                this.doFormatting = !this.config.bypass_limits_formatting;
                this.doValidation = !this.config.bypass_limits_validation;

                this._tableRenderComplete = false;
                let $limits: Observable<any> = of(null);
                if (this.doFormatting || this.doValidation || this.autoFormattingIds?.length) {
                    const propertyIds = this.constant_properties?.map(item => item.id);
                    $limits = this.getConstantPropertyComponentTypes(this.component_type.id, propertyIds).pipe(
                        catchError(e => {
                            console.log("ERROR: Component Events Table (getConstantPropertyComponentTypes)", e);
                            return of(null)
                        }));
                }

                return this.getComponentRelationshipData().pipe(switchMap(() => {
                    return $limits;
                }));
            }),
            finalize(() => {
                if (this.loading_next) {
                    this.loading_next = false;
                    this.changeDetectorRef.markForCheck();
                }
            })
        ).subscribe(() => {
            this.createComponentsTable();
            this.setFilterTableButtonConfig();

            if (this.columns && (this.config.show_aggregations || this.config.show_aggregations_top)) {
                this.addAggregationRow();
            }
            if (this.page_size > 100 && this.components?.length >= 100) {
                this.notification.openSuccess("Table is ready for editing.");
            }

            this._tableRenderComplete = true;
            this.changeDetectorRef.markForCheck();
        });
    }

    getComponents() {
        this.loading_next = true;
        this.changeDetectorRef.markForCheck();

        const base = this.config.selected_component_type.attributes.base_type;

        if (this.componentEventsTableService.shouldUseUpdatedFiltering(this.config)) {
            if (!base) {
                this.loading_next = false;
                return of([]);
            }
            return this.componentEventsTableService.getComponentsByConstantDateFilter(
                base,
                this.config,
                this.dateInst.dtp,
                this.search_by_name,
                this.user_filters,
                this.query_builder_filters,
                this.page_index + 1,
                this.page_size,
                'name'
            ).pipe(
                tap((result: ListResponse<WireComponent>) => {
                    if (!result) {
                        this.component_total = 0;
                        this.components = [];
                    } else {
                        this.components = result.data;
                        this.component_total = result.meta.count;
                    }
                })
            );
        } else {
            const options = new SearchQueryOptions();
            options.filters = this.componentEventsTableService.getComponentsFilter(
                this.config,
                this.dateInst.dtp,
                this.search_by_name,
                this.user_filters,
                this.query_builder_filters
            );
            options.page_size = this.page_size;
            options.page_number = this.page_index + 1;
            options.sort = 'name';

            let baseType = base;
            if (baseType && ['resource', 'equipment'].includes(baseType)) {
                baseType = baseType + '_light';
            }

            if (baseType) {
                return this.api[baseType].searchMany(options)
                    .pipe(
                        tap((result: ListResponse<WireComponent>) => {
                            if (!result) {
                                this.component_total = 0;
                                this.components = [];
                            } else {
                                this.components = result.data;
                                this.component_total = result.meta.count;
                            }
                        })
                    );
            } else {
                this.loading_next = false;
                return of([]);
            }
        }
    }

    pageData(event) {
        this.page_index = event.pageIndex;
        this.page_size = event.pageSize;
        this.refreshComponents();
    }

    getComponentProperties(): Observable<any> {
        let propIds = getPropertyIds(this.config.selected_cols?.component_type);
        propIds = this.componentEventsTableService.addTimeFilterProperties(this.config, propIds);
        this.config.selected_cols?.component_type?.filter(c => c.related_type_id && c.type === 'constant_property')?.map(c => {
            this.componentTypePropertyMap[c.related_type_id] = (this.componentTypePropertyMap[c.related_type_id] || []).concat([c.id]);
        })
        const componentTypeIds = [this.component_type.id].concat(Object.keys(this.componentTypePropertyMap) || []);
        const $properties = this.eventsService.getComponentTypeProperties(componentTypeIds, propIds)
            .pipe(tap(result => {
                this.constant_properties = result.data;
                this.mapComponentTypeProperties();
            }));
        return $properties;
    }

    getComponentTypeComponentTypes() {
        let ctIds = getComponentTypeIds(this.config.selected_cols?.component_type);
        let allCtIds = (ctIds || []).concat(getRelatedComponentTypeIds(this.config.selected_cols?.component_type));

        const $componentTypeComponentTypes = this.componentTypeDataService.getComponentTypeComponentTypeRelationships(this.component_type.id, ctIds)
            .pipe(tap(result => {
                this.ctCtDict = result;
            }));

        const $componentTypes = this.componentTypeDataService.getComponentTypes(allCtIds).pipe(tap(result => {
            this.componentTypes = result.data.filter(ct => ctIds.includes(ct.id));
            result.data.forEach(ct => this.ctDict[ct.id] = ct);
        }))
        return forkJoin([$componentTypeComponentTypes, $componentTypes]);
    }

    getComponentRelationshipData(): Observable<any> {
        this.auditMixinDict = {};
        this.generic_constants = {};
        utils.sortObjectsByProperty(this.components, 'name');
        const component_ids = this.components.map(component => component.id);

        // Check if we need to fetch component relationships for selector display
        const needComponentRelationships = this.config.selected_cols?.component_type?.some(column =>
            column.type === 'component_type' && column.format?.aggregation_type !== 'count'
        );

        const requests: Observable<any>[] = [this.getConstantComponents(component_ids)];
        if (needComponentRelationships) {
            requests.push(this.getComponentComponents(component_ids));
        }

        return forkJoin(requests);
    }

    mapComponentTypeProperties(): void {
        this.cp_dict = {};
        this.components_properties = [];
        this.constant_properties.forEach(cp => {
            this.cp_dict[cp.id] = cp;
            if (cp.attributes.name) {
                // This is here for the view
                if (!this.components_properties.includes(cp.attributes.name)) {
                    this.components_properties.push(cp.attributes.name);
                }
            }
        });
        this.attribute_cols = this.config.selected_cols?.component_type.filter(c => c.type === 'attribute').map(c => getColumnId(c)) || ['name'];
        this.attribute_cols_set = new Set(this.attribute_cols);
        this.attribute_cols_name_dict = {};
        if (this.config.selected_cols?.component_type) {
            this.components_properties = this.config.selected_cols.component_type.map(item => {
                return this.cp_dict[item.id]?.attributes.name || item.id;
            });
        } else {
            this.components_properties = this.attribute_cols.concat(this.components_properties);
        }
    }

    getComponentComponents(componentIds: ModelID[]) {
        return this.componentDataService.getComponentComponentData(componentIds, this.componentTypes.map(ct => ct.id), this.ctCtDict,
            this.component_type.id, this.config.component_type_date_filters, this.dtp).pipe(
            map(componentData => {
                this.componentComponentTypeMap = Object.assign({}, this.componentComponentTypeMap || {}, componentData);
                this.componentComponentDict = deepCopy(this.componentComponentTypeMap.components);
                this.setAuditData(componentIds, null, componentData.componentComponents);
                this.changeDetectorRef.markForCheck();
            })
        )
    }

    getConstantComponents(ids: ModelID[]): Observable<GenericConstantApiResponse> {
        // TODO limit this to only selected attributes when config gets updated
        const propIds = getPropertyIds(this.config.selected_cols?.component_type, false);

        let aggregations: ConstantRelationshipAggregationRequest[] = [];
        let componentTypeRelationships = {};

        const showAggregations = this.config.show_aggregations || this.config.show_aggregations_top;

        this.config.selected_cols?.component_type.forEach(column => {
            if (column.type === 'component_type') {
                // For component type columns, build relationships
                const aggregationType = column.format?.aggregation_type || 'default';
                componentTypeRelationships[column.id] = {
                    aggregation_type: aggregationType
                };
                // For component type columns:
                // - If aggregation type is 'count', add for per-row counts
                // - If showing aggregations at top/bottom, always add for total count
                if (aggregationType === 'count' || showAggregations) {
                    // For top-level aggregation of component types with 'none' or 'default', use 'count'
                    const modifiedColumn = showAggregations && (aggregationType === 'none' || aggregationType === 'default')
                        ? {...column, format: {...column.format, aggregation_type: 'count'}}
                        : column;
                    aggregations.push(new ConstantRelationshipAggregationRequest(modifiedColumn, 'component', this.component_type.id));
                }
            } else if (column.type === 'constant_property' && column.related_type_id) {
                // For linked constant properties, create aggregation with the related type
                aggregations.push(new ConstantRelationshipAggregationRequest(column, 'component', column.related_type_id));
            } else {
                // For regular property columns, always add aggregation
                aggregations.push(new ConstantRelationshipAggregationRequest(column, 'component', this.component_type.id));
            }
        })
        let relatedAttributeMap = {};
        this.config.selected_cols?.component_type?.filter(c => c.related_type_id && c.type === 'attribute')?.map(c => {
            relatedAttributeMap[c.related_type_id] = (relatedAttributeMap[c.related_type_id] || []).concat([c.id]);
        })
        const attributes = getAttributeIds(this.config.selected_cols.component_type, false)?.filter(a => ['start_time', 'end_time', 'name'].includes(a));

        return this.componentEventsTableService.getApiComponentConstants(ids, propIds, attributes, this.componentTypePropertyMap, relatedAttributeMap, aggregations, showAggregations, componentTypeRelationships)
            .pipe(tap((response: GenericConstantApiResponse) => {
                this.generic_constants = Object.assign({}, this.generic_constants, this.mapRelationshipConstants(response.data, relatedAttributeMap));
                this.setAuditData(ids, response.data);
                this.changeDetectorRef.markForCheck();
            }));
    }

    private extractAggregationKey(colId: string): string {
        if (colId.includes(':')) {
            const [typeId, propertyId] = colId.split(':');
            return typeId === this.component_type.id ? propertyId : colId;
        }
        return colId;
    }

    shouldFormatAsInteger(aggregation: string | undefined): boolean {
        return aggregation === 'count' || aggregation === 'none';
    }

    mapRelationshipConstants(constantDict: GenericConstantApiResponse, relatedAttributes: IDMap<string[]>) {

        const topLevelAggregated = constantDict['_aggregated'];
        if (topLevelAggregated) {
            this.aggregation_row = {};
            for (const colId in topLevelAggregated) {
                const key = this.extractAggregationKey(colId);
                this.aggregation_row[key] = topLevelAggregated[colId];
                // Convert datetime values to client timezone
                if (this.aggregation_row[key]?.data_type === 'datetime' && this.aggregation_row[key]?.value) {
                    this.aggregation_row[key].value = stringDate(this.aggregation_row[key].value);
                }
            }
        }

        for (const componentId in constantDict) {
            if (componentId === '_aggregated') continue;

            const componentEntry = constantDict[componentId];
            const relationships = componentEntry['_relationships'];

            const relatedPropertyIds = new Set<string>();

            if (relationships) {
                for (const componentTypeId in relationships) {

                    const properties = relationships[componentTypeId]._aggregated || {};
                    for (const propertyId in properties) {
                        const combinedId = componentTypeId + ":" + propertyId;

                        let constant = {...properties[propertyId]};
                        constant.type = 'constant';

                        // Ensure aggregated values are treated as displayable
                        if (!constant.hasOwnProperty('editable')) {
                            constant.editable = false;
                        }
                        if (!constant.hasOwnProperty('locked')) {
                            constant.locked = false;
                        }

                        if (this.selected_cols_dict[combinedId]?.format?.aggregation_type === 'none') {
                            constant.value = [];
                            Object.keys(relationships[componentTypeId])?.filter(id => id !== '_aggregated')?.forEach(linkedId => {
                                let nextValue = relationships[componentTypeId][linkedId]?.[propertyId]?.value;
                                // Skip null/undefined values to avoid adding empty arrays
                                if (nextValue === null || nextValue === undefined) {
                                    return;
                                }
                                if (constant.data_type === 'datetime') {
                                    nextValue = stringDate(nextValue);
                                }
                                constant.value = constant.value.concat([nextValue]);
                            })
                            // If the array is empty, set value to null to display nothing instead of []
                            if (constant.value.length === 0) {
                                constant.value = null;
                            }
                            constant.data_type = 'list';
                        }

                        // Store propertyId for later cleanup
                        relatedPropertyIds.add(propertyId);

                        // Add the flattened value to the component entry
                        componentEntry[combinedId] = constant;
                    }

                    // Handle component_type columns with aggregation_type 'none' - collect names from linked components
                    // This is needed when there's no _aggregated but there are direct linked component entries
                    const colConfig = this.selected_cols_dict[componentTypeId];
                    if (colConfig?.type === 'component_type' && colConfig?.format?.aggregation_type === 'none') {
                        const linkedComponentIds = Object.keys(relationships[componentTypeId]).filter(id => id !== '_aggregated');
                        const names = linkedComponentIds
                            .map(linkedId => relationships[componentTypeId][linkedId]?.name?.value)
                            .filter(name => name != null);
                        componentEntry[componentTypeId] = {
                            type: 'constant',
                            data_type: 'list',
                            value: names.length > 0 ? names : null,
                            editable: false,
                            locked: false
                        };
                    }

                    // Remove the _relationships key
                    delete componentEntry['_relationships'];
                }

                // Remove invalid properties that are replaced by flattened ones
                for (const key of Object.keys(componentEntry)) {
                    if (
                        relatedPropertyIds.has(key) &&
                        componentEntry[key]?.type === 'invalid'
                    ) {
                        delete componentEntry[key];
                    }
                }
            }
        }
        return constantDict;
    }

    setAuditData(ids: ModelID[], constants?: GenericConstantData, componentComponents?: IDMap<IDMap<ComponentComponent[]>>): void {
        const type = constants ? 'constant_component' : 'component';
        ids.forEach(id => {
            this.auditMixinDict[id] = this.auditMixinDict[id] || {};
            const keys = constants?.[id] ? Object.keys(constants[id]) : Object.keys(componentComponents?.[id]);
            for (let key of keys) {
                let auditItemId: ModelID;
                if (type === 'component') {
                    const rels = componentComponents[id][key]?.[0]?.relationships;
                    if (!rels) continue;
                    auditItemId = this.ctCtDict[key]?.isUnique ? null : rels.first_component.data.id === id ? rels.second_component.data.id : rels.first_component.data.id;
                }
                if (this.cp_dict[key] || this.ctDict[key]) {
                    this.auditMixinDict[id][key] = {
                        id: id,
                        auditItemId: auditItemId, //for multiselects with only one item
                        type: type,
                        attributes: this.cp_dict[key] ? constants[id][key] : componentComponents?.[id]?.[key]?.[0]?.attributes,
                        relationships: componentComponents?.[id]?.[key] ? {data: componentComponents?.[id]?.[key]} : null
                    };
                }
            }
        });
    }

    saveComponent(component: WireComponent, column: ModelID, $event) {
        if (!(component.type && component.id)) {
            return;
        }

        const save_me = {id: component.id, type: component.type, attributes: {}};
        if (column === 'start_time') {
            save_me.attributes['start_time'] = $event?.toISOString() || null;
        } else if (column === 'end_time') {
            save_me.attributes['end_time'] = $event?.toISOString() || null;
        } else if (column === 'name') {
            save_me.attributes['name'] = component.attributes.name;
        }

        if ((column === 'start_time' || column === 'end_time') && !this.eventsService.checkStartAndEndDates(component, 'start_time', 'end_time')) {
            return;
        }
        const mylist = ['start_time', 'end_time', 'name'];

        if (mylist.includes(column) && component && component.type) {

            let constants = deepCopy(this.generic_constants[component.id]) || {[column]: {}};
            constants[column].value = save_me.attributes[column];
            if (!this.validationService.validateValue(column, constants, this.validationDict)) {
                return;
            }

            this.api[component.type].obsPatch(save_me).pipe(take(1)).subscribe(result => {
                if (result.data) {
                    this.generic_constants[component.id][column]['value'] = result.data.attributes?.[column];
                    this.notification.openSuccess("Component saved.");
                }
                this.changeDetectorRef.markForCheck();
            });
        }
    }

    updateComponentComponentRelationship(component: WireComponent, componentTypeId: ModelID, $event) {
        if (!$event) return;
        try {
            // Normalise both shapes ($event-as-array from multi-select, or
            // {value} from unique single-select where `value` may itself be
            // an array) into one newValue + newSelectedValues pair, so the
            // unique branch below can't silently coerce an array into [undefined].
            let newSelectedValues;
            let newValue;
            if (Array.isArray($event)) {
                newSelectedValues = $event || [];
                newValue = newSelectedValues[0];
            } else {
                newValue = Array.isArray($event.value) ? $event.value[0] : $event.value;
                newSelectedValues = newValue != null ? [newValue] : [];
            }
            const oldComponentComponents = this.componentComponentTypeMap.componentComponents?.[component.id];
            const oldComponents = this.componentComponentTypeMap.components?.[component.id];
            this.componentDataService.saveLinkedComponents(newSelectedValues, oldComponentComponents, oldComponents, component.id, componentTypeId, this.ctCtDict)
                .pipe(
                    takeUntil(this.onDestroy),
                    tap((result: RelMappingResult) => {
                        if (result.failures.length > 0) {
                            console.log("ERROR: ComponentEventsTable (updateComponentComponentRelationship) ", result.failures);
                            this.notification.openError(`${result.successes.length} saved. ${result.failures.length} component link(s) failed to update. Please see the console for details.`);
                        } else if (result.successes.length + result.deletedIds.length > 0) {
                            this.notification.openSuccess("Components updated successfully.");
                        }
                        // else: zero-diff save - no toast (e.g., user re-closed a dropdown without changes)

                        // Reset the dropdown's pending/internal selection on every outcome -
                        // including clean success - so the table is consistent with the
                        // newly-saved baseline regardless of save result.
                        this.clearConstantService.clearInternalSelected();

                        // Guard sparse cells: if the user edits a relationship type that
                        // wasn't part of the most recent getComponentComponentData fetch,
                        // the (componentId, componentTypeId) cell can be undefined.
                        const ccByCt = (this.componentComponentTypeMap.componentComponents[component.id] ??= {});
                        const compByCt = (this.componentComponentTypeMap.components[component.id] ??= {});
                        const dictByCt = (this.componentComponentDict[component.id] ??= {} as any);
                        const oldCcCell = (ccByCt[componentTypeId] ??= []);

                        // Apply only server-confirmed mutations so the diff baseline stays in
                        // sync with server truth - a follow-up Save then retries failed rows
                        // instead of skipping them.
                        const deletedSet = new Set(result.deletedIds);
                        const savedRows = result.successes.map(s => s.data);
                        const reconciledCc = oldCcCell
                            .filter(cc => !deletedSet.has(cc.id))
                            .concat(savedRows);
                        ccByCt[componentTypeId] = reconciledCc;

                        if (!this.ctCtDict[componentTypeId].isUnique) {
                            const reconciledComps = reconciledCc.map(cc => ({
                                id: cc.relationships.first_component.data.id === component.id
                                    ? cc.relationships.second_component.data.id
                                    : cc.relationships.first_component.data.id
                            }));
                            compByCt[componentTypeId] = reconciledComps;
                            dictByCt[componentTypeId] = deepCopy(reconciledComps);
                        } else if (savedRows.length) {
                            // Unique save succeeded - surface the user's selection. A unique
                            // insert only succeeds when no conflicting link exists at insert
                            // time (enforced by the tr_check_component_component_valid DB
                            // trigger), so the old link is guaranteed gone server-side here
                            // even if its delete was reported as a failure (e.g. a request
                            // that timed out client-side but actually committed). The baseline
                            // is therefore just the new value, never old+new.
                            compByCt[componentTypeId] = [newValue];
                            dictByCt[componentTypeId] = [newValue];
                        } else if (reconciledCc.length === 0) {
                            // Unique stand-alone delete succeeded (or nothing was there).
                            compByCt[componentTypeId] = [];
                            dictByCt[componentTypeId] = [];
                        }
                        // else: unique delete failed and no insert succeeded (the still-present
                        // old link makes the trigger reject the paired save) - leave
                        // compByCt/dictByCt as-is so the old value stays visible and the next
                        // edit re-attempts the delta.

                        this.changeDetectorRef.markForCheck();
                    }),
                    catchError(e => {
                        this.notification.openError("Error updating components.")
                        return of(e);
                    })
                ).subscribe();
        } catch (e) {
            this.notification.openError(`Error updating components: ${e}`)
        }
    }

    createUserFilters() {
        if (this.filter_string === '') {
            // Search clicked with no substring to search on
            this.notification.openError('Please enter text to search on before searching', 2000);
            return;
        }
        this.filter_warning = '';
        if (!this.filter_string) {
            this.user_filters = null;
            this.loading_next = true;
            this.changeDetectorRef.markForCheck();
            this.applyFilter('');
            this.refreshComponents();
            return;
        }
        const filter_value = '%' + this.filter_string + '%';
        this.user_filters = {or: []};
        // Always filter on name unless "name" is not a selected column
        const name_selected = this.config.selected_cols.component_type.some(col =>
            col.type === 'attribute' && col.id === 'name' && !col.related_type_id);
        if (name_selected) {
            this.user_filters.or.push({op: 'ilike', name: 'name', val: filter_value});
        }
        this.user_search_selections.forEach(columnId => {
            const column = this.selected_cols_dict[columnId];
            if (!column) {
                return;
            }
            const clause = this.componentEventsTableService.buildUserSearchFilter(column, filter_value);
            if (clause) {
                this.user_filters.or.push(clause);
            }
        });
        if (this.user_filters.or.length === 0) {
            this.notification.openError('Please select a column to search on before searching', 2000);
            return;
        }
        this.loading_next = true;
        this.changeDetectorRef.markForCheck();
        this.page_index = 0;
        this.paginator.pageIndex = 0;
        this.applyFilter('');
        this.refreshComponents();
    }

    clearSearch() {
        this.generic_constants = {};
        this.filter_string = '';
        this.user_search_selections = [];
        this.user_filters = null;
        this.page_index = 0;
        this.paginator.pageIndex = 0;
        this.applyFilter('');
        this.refreshComponents();
        this.changeDetectorRef.markForCheck();
    }

    getTree(column) {
        let col = this.selected_cols_dict[column];
        const type = col.related_type_id ? {
            id: col.related_type_id,
            type: col.related_type
        } : this.config.selected_component_type;
        this.formDialogService.openConstantPropertyCalcTreeDialog(type, col.id);
    }

    checkLock(component, column) {
        if (!this.can_unlock) {
            return;
        }
        this.lockDataService.getLocks('component', component, this.cp_dict?.[column] || column, this.tileData.tile.id)
    }

    createComponentsTable(): void {
        this.columns = getColIds(this.config.selected_cols.component_type.filter(c => {
            return c && (
                (c.type === 'attribute' && ['name', 'start_time', 'end_time', 'changed_by'].includes(c.id)) ||
                (c.type === 'constant_property' && this.cp_dict[c.id]) ||
                (c.type === 'component_type' && this.ctDict[c.id]) ||
                (c.related_type === 'component_type' && this.cp_dict[c.id])
            );
        }))
        this.columns = ["Expand"].concat(this.columns);

        if (this.config.enable_row_selection) {
            this.columns = ["Select"].concat(this.columns);
        }
        this.user_search_fields = [];
        const datetime_attribute_ids = new Set(['start_time', 'end_time']);
        this.columns.forEach(c => {
            if (['Select', 'name', 'Expand'].includes(c)) {
                return;
            }
            const col = this.selected_cols_dict[c];
            const isDatetimeCp = col?.type === 'constant_property' && this.cp_dict[col.id]?.attributes.data_type === 'datetime';
            const isDatetimeAttr = col?.type === 'attribute' && datetime_attribute_ids.has(col.id);
            if (isDatetimeCp || isDatetimeAttr) {
                return;
            }
            this.user_search_fields.push({
                name: col?.title || this.cp_dict[c]?.attributes.name || c,
                value: c
            });
        });

        this.agg_columns = this.columns.map(c => 'aggregation' + c);
        this.initialiseColumnFormats();

        this.dataSource.data = this.components;
        this.dataSource.filterPredicate = (data, filter) => {
            const columnMatched = this.config.selected_cols.component_type.reduce((boolean, column) => {
                const constant = this.generic_constants[data.id]?.[getColumnId(column)];
                return (boolean || (constant && isConstant(constant) &&
                    constant.value?.toString().toLowerCase().includes(filter.toLowerCase())));
            }, false);
            return (data.attributes.name && data.attributes.name.toLowerCase().includes(filter.toLowerCase())) || columnMatched;
        };

        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (data, sortHeaderId) => {
            const column = this.selected_cols_dict[sortHeaderId];
            if (!column) {
                return;
            } // Select and Index columns
            const col_id = getColumnId(column);
            switch (true) {
                case col_id === "name":
                    return data.attributes.name;
                case column.type === 'constant_property':
                    if (!isConstant(this.generic_constants[data.id][col_id])) {
                        return;
                    }
                    if (this.cp_dict[col_id].attributes.data_type === 'float') {
                        return (this.generic_constants[data.id][col_id] as ConstantField).value;
                    } else if (this.cp_dict[col_id].attributes.data_type === 'datetime') {
                        return new Date((this.generic_constants[data.id][col_id] as ConstantField).value);
                    } else {
                        return (this.generic_constants[data.id][col_id] as ConstantField).value;
                    }
                case col_id === "start_time":
                    return new Date(data.attributes.start_time);
                case col_id === "end_time":
                    return new Date(data.attributes.end_time);
                default:
                    return "";
            }
        };
        // this.dataSource.paginator = this.paginator;

        this.eventsService.event_state = {};
        this.eventsService.error_list = {};
        this.expandedElement = null;
        this.loading_next = false;
        this.changeDetectorRef.markForCheck();
        if (this.tableHeightTimeoutId !== null) {
            clearTimeout(this.tableHeightTimeoutId);
        }
        this.ngZone.runOutsideAngular(() => {
            this.tableHeightTimeoutId = setTimeout(() => {
                this.tableHeightTimeoutId = null;
                this.ngZone.run(() => {
                    this.setTopScroll();
                    this.setTableHeight();
                });
            });
        });
    }

    selectEvent(row, checked) {
        this.rows_selection_status[row.id] = checked.checked;
    }

    selectAll(checked) {
        this.rows_selection_status = {};
        this.components.forEach(row => {
            this.rows_selection_status[row.id] = checked.checked;
        });
    }

    addAggregationRow() {
        // Start with existing aggregation_row from backend or empty object
        let row = this.aggregation_row || {};
        this.columns.forEach(col_id => {
            if (!['Select', 'Index', 'Expand'].includes(col_id)) {
                // Only calculate local aggregation if backend didn't provide one
                if (!row[col_id]) {
                    row = this.aggregateColumn(col_id, row);
                }
            }
        });
        this.aggregation_row = row;
    }

    aggregateColumn(col_id, row) {
        const column = this.selected_cols_dict[col_id];
        let agg_type: string = (column?.format?.aggregation_type !== 'none' &&
                column?.format?.aggregation_type)
            || this.cp_dict[column.id]?.attributes?.aggregation
            || 'total';
        let is_numeric = this.cp_dict.hasOwnProperty(column.id) &&
            this.cp_dict[column.id].attributes.data_type === 'float';

        let count: number = 0;
        let total: number = 0;
        this.dataSource.filteredData.forEach(comp => {
            const gc = this.generic_constants[comp.id]?.[col_id];
            if (is_numeric && isConstant(gc)) {
                let val = (this.generic_constants[comp.id][col_id] as ConstantField).value;
                val = parseFloat(val?.toString());
                if (val !== null && val !== undefined && !isNaN(val)) {
                    total += val;
                    count += 1;
                }
            } else {
                // Count if it has a value
                if (((gc && (isConstant(gc) && gc.value) || !isConstant(gc)) || comp.attributes[col_id]) && agg_type !== 'none') {
                    count += 1;
                }
            }
        });

        let aggregatedValue = null;
        if (count !== 0) {
            switch (true) {
                case agg_type === 'total' && is_numeric === true:
                    aggregatedValue = utils.deepCopy(total);
                    break;
                case (agg_type === 'average' || agg_type === 'mean') && is_numeric === true:
                    aggregatedValue = utils.deepCopy(total) / utils.deepCopy(count);
                    break;
                case agg_type === 'count' || !is_numeric:
                    aggregatedValue = utils.deepCopy(count);
                    break;
                case agg_type === 'none':
                    break;
                default:
                    return row;
            }
        } else if ((agg_type !== 'none' && is_numeric) || agg_type === 'count') {
            aggregatedValue = 0;
        }

        // Check if row[col_id] already exists and has the backend structure
        if (aggregatedValue !== null) {
            if (row[col_id] && typeof row[col_id] === 'object' && 'value' in row[col_id]) {
                // Update just the value property of the existing backend structure
                row[col_id] = {...row[col_id], value: aggregatedValue};
            } else {
                // For new entries, create a simple value
                row[col_id] = aggregatedValue;
            }
        }

        return row;
    }

    saveConstant(component, cpId: ModelID, $event) {
        let $sub;
        if (!isConstant(this.generic_constants[component.id][cpId])) {
            return;
        }

        let constant_value = (this.generic_constants[component.id][cpId] as ConstantField).value;

        this.componentEventsTableService.$validateConstantValue.pipe(
            take(1),
            concatMap(newValue => {
                if (!newValue.value && newValue.validated) {
                    return of(false);
                }
                if (!this.validationService.validateValue(cpId, this.generic_constants[component.id], this.validationDict)) {
                    return of(null);
                }
                constant_value = newValue.value;
                (this.generic_constants[component.id][cpId] as ConstantField).value = constant_value;
                return this.genericConstantData.saveComponentConstant(
                    component.id,
                    cpId,
                    constant_value
                );
            })).subscribe(result => {
            if (result) {
                this.notification.openSuccess("Value saved.");
                if (typeof result === 'object' && typeof this.auditMixinDict[component.id][cpId].attributes === 'object') {
                    const currentUser = this.appScope.current_user;
                    const currentValue = this.auditMixinDict[component.id][cpId].attributes;
                    result = {
                        ...currentValue,
                        ...result,
                        created_by_name: currentValue.created_by_name ?? currentUser.name,
                        created_on: currentValue.created_on ?? new Date().toISOString(),
                        changed_by_name: currentUser.name,
                        changed_on: new Date().toISOString(),
                    }
                }
                this.auditMixinDict[component.id][cpId].attributes = result;
                if (this.config.show_aggregations || this.config.show_aggregations_top) {
                    this.aggregation_row = this.aggregateColumn(cpId, this.aggregation_row || {});
                }
                this.updateConditionalColumnFormats();
                const constantProperty = this.cp_dict[cpId];

                if (this.doFormatting || this.autoFormattingIds.includes(cpId)) {
                    this.componentEventsTableService.getConstantConditionalFormat(
                        component.id, this.cp_class_dict, constantProperty, this.selected_cols_dict[cpId], this.limits_map, constant_value, !this.doValidation);
                }
            }
            if (result === false) {
                //Specifically user failed to reenter a correct value when prompted to do so
                this.notification.openError("Value not saved.");
            }
            this.changeDetectorRef.markForCheck();
        });

        this.componentEventsTableService.detectComponentConstantLimits(null, constant_value, this.limits_map, this.selected_cols_dict[cpId], component, this.doValidation);
    }

    // Component Type Form
    editComponentType(component_type) {
        // FIXME put call for full list onto the constant properties form after formula builder merge
        this.notification.openSuccess("Loading component type form...");
        this.$constant_properties = utils.refreshSubscription(this.$constant_properties);
        this.$constant_properties = this.api.constant_property.searchMany().pipe(takeUntil(this.onDestroy)).subscribe(results => {
            const constant_properties_list = results.data;
            utils.fill_object_relations([component_type], constant_properties_list, 'constant_properties');
            const dialogRef = this.formDialogService.editComponentType(component_type, constant_properties_list);
            dialogRef.afterClosed().pipe(take(1)).subscribe(result => {
                if (result) {
                    if (component_type) {
                        component_type = result;
                    }
                    this.createComponentsTable();
                }
            });
        });
    }

    initialiseColumnFormats() {
        this.format_dict = {};
        const columns = this.config.selected_cols?.component_type || [];
        columns.forEach(column => {
            this.format_dict[getColumnId(column)] = this.tableUtils.getColumnFormats(column.format);
        });
        this.updateConditionalColumnFormats();
        this.initialiseRowHeights();
    }

    initialiseRowHeights() {
        this.rowHeightDict = {};
        ['', 'aggregation_top_', 'aggregation_bottom_', 'detail_'].forEach(row => {
            const rowId = row + 'row_height';
            this.rowHeightDict[rowId] = {height: this.config[rowId] || 'auto', allow_resize: true};
        });
    }

    getDetailRowHeight(row, fallback = 'auto'): string {
        if (this.expandedElement?.id !== row.id) return '0px';
        const height = this.rowHeightDict.detail_row_height?.height;
        return height && height !== 'auto' ? height + 'px' : fallback;
    }

    canEditComponent() {
        return this.userService.canEditComponent(this.component_type?.attributes?.base_type);
    }

    showCreateComponent() {
        return this.config.can_create_component;
    }

    canCreateComponent() {
        return this.userService.canCreateComponent(this.component_type?.attributes?.base_type);
    }

    newComponent() {
        this.router.navigate([{outlets: {component_panel: ['component', this.tileData.tile.id]}}],
            {relativeTo: this.activatedRoute, queryParams: this.activatedRoute.snapshot.queryParams});
    }

    editComponent(component, $event) {
        $event.stopPropagation();
        this.router.navigate([{outlets: {component_panel: ['component-detail', component.id, this.tileData.tile.id]}}],
            {relativeTo: this.activatedRoute, queryParams: this.activatedRoute.snapshot.queryParams});

    }

    /** Track function for the column @for loop (columns are string IDs). */
    trackByColumn(_index: number, column: string): string {
        return column;
    }

    resizeColumn(column: string, width: number): void {
        if (!this.format_dict?.[column]) {
            return;
        }
        this.format_dict[column].width = width;
    }

    updateConditionalColumnFormats() {
        const data = {
            constant_property: {data: this.generic_constants, dict: this.cp_dict}
        };
        this.conditional_dict = this.conditionalService.extractConditions(this.conditions, this.components, this.columns,
            data);

        this.formats = this.tableUtils.combineStyles(this.format_dict, this.conditional_dict, this.components);
        this.formats = this.tableUtils.updateStylesForDisabled(
            this.config.selected_cols?.component_type || [], this.components, this.cp_dict, this.generic_constants, this.formats
        );
    }

    ngOnDestroy(): void {
        if (this.tableHeightTimeoutId !== null) {
            clearTimeout(this.tableHeightTimeoutId);
            this.tableHeightTimeoutId = null;
        }
        this.tableUtils.removeListeners();
        this.onDestroy.next();
        this.onDestroy.complete();
    }

    applyFilter(filterValue: any) {
        filterValue = filterValue.trim().toLowerCase();
        this.dataSource.filter = filterValue;
        if (filterValue) {
            this.filter_warning = 'Displaying current Page filter results. Please click Search to display the full table results.';
        }
        this.filteredData.next(filterValue);
    }

    getEventDataFileType($event) {
        this.componentEventsTableService.openFileFormatModal($event, this.downloadComponent, this.config.download_file_type,
            'component_types', [this.component_type.id]);
    }

    downloadComponentData(filetype: FileDownloadOption = 'formatted_csv', filters?: RESTFilter, constantDateFilter?: ConstantDateFilter) {
        if (!filters) {
            if (this.componentEventsTableService.shouldUseUpdatedFiltering(this.config)) {
                filters = this.componentEventsTableService.getComponentsFilterNonDate(
                    this.config, this.dateInst.dtp, this.search_by_name,
                    this.user_filters, this.query_builder_filters);
                // A004: abort on empty-array sentinel (search_by_name required but blank).
                if (this.componentEventsTableService.isNameSearchAbortSentinel(filters)) {
                    return;
                }
                constantDateFilter = ComponentEventsTableService.buildConstantDateFilter(this.config, this.dateInst.dtp);
            } else {
                filters = this.componentEventsTableService.getComponentsFilter(this.config,
                    this.dateInst.dtp, this.search_by_name,
                    this.user_filters, this.query_builder_filters);
            }
        }

        let download_title = this.tileData?.tile?.attributes?.title;
        if (!download_title) {
            download_title = this.headerData.title;
        } else {
            if (this.headerData.title) {
                download_title = utils.deepCopy(this.headerData.title).concat("_", download_title);
            }
        }

        const print_title = utils.printDocTitle(download_title, this.dateInst.dtp.start,
            this.dateInst.dtp.end);

        this.csvExporter.downloadModelData('Component', print_title, filters, this.config.selected_cols.component_type,
            this.cp_dict, this.ctDict, undefined, filetype, constantDateFilter);
    }

    downloadComponent = (filetype: FileDownloadOption = 'formatted_csv', fileConstantPropertyIDs: ModelID[]) => {
        let filters: RESTFilter;
        let constantDateFilter: ConstantDateFilter;

        if (this.componentEventsTableService.shouldUseUpdatedFiltering(this.config)) {
            filters = this.componentEventsTableService.getComponentsFilterNonDate(
                this.config, this.dateInst.dtp, this.search_by_name,
                this.user_filters, this.query_builder_filters);
            // A004: getComponentsFilterNonDate returns [] as an abort sentinel when
            // search_by_name is required but blank. Abort the download in that case.
            if (this.componentEventsTableService.isNameSearchAbortSentinel(filters)) {
                return;
            }
            constantDateFilter = ComponentEventsTableService.buildConstantDateFilter(this.config, this.dateInst.dtp);
        } else {
            filters = this.componentEventsTableService.getComponentsFilter(this.config,
                this.dateInst.dtp, this.search_by_name,
                this.user_filters, this.query_builder_filters);
        }

        const componentIds = Object.keys(this.rows_selection_status).filter(key => this.rows_selection_status[key]);
        const fileTypes: FileDownloadOption[] = FILE_DOWNLOAD_OPTIONS.map(opt => opt.value);
        if (filetype === 'files') {
            if (this.isDownloading) {
                return;
            }
            this.isDownloading = true;
            this.setButtons();
            // When rows are manually selected, send their IDs directly.
            // Otherwise send the filter spec (+ constant_date_filter when active);
            // the backend resolves component IDs inside the Celery worker.
            if (this.componentEventsTableService.shouldUseUpdatedFiltering(this.config) && !componentIds.length) {
                this.componentEventsTableService.downloadComponentFiles(
                    filters, fileConstantPropertyIDs, undefined, constantDateFilter);
            } else {
                this.componentEventsTableService.downloadComponentFiles(filters, fileConstantPropertyIDs, componentIds);
            }
        } else if (fileTypes.includes(filetype)) {
            const ft = filetype as FileDownloadOption;
            this.downloadComponentData(ft, filters, constantDateFilter);
        }
    }

    /** Sends an invoice request to JDE
     * @param component_ids: list of components being invoiced
     * @param client_exporter_name: type of invoice request being sent (e.g. debit, credit)
     */
    push_data_to_client(componentIds: string[], exporterType: ExporterType, clientExporterName: string) {
        this.componentEventsTableService.push_data_to_client(componentIds, exporterType, clientExporterName).subscribe((resp) => {
            this.messages.push(resp);
            componentIds.forEach(component_id => {
                this.component_state[component_id] = {state: 'success', message: resp['message']};
            });
        }, (err) => {
            console.error("Error while exporting data to client:", err);
            componentIds.forEach(component_id => {
                this.component_state[component_id] = {state: 'error', message: err.error.message ?? err.message};
            });
        });
    }

    push_selected_components_to_client(exportComponent: ExportComponentConfig, selected_rows?: ModelID[]) {
        const clientExporterName = exportComponent.export_name;
        const exporterType = exportComponent.export_type as ExporterType;

        if (selected_rows === undefined) {
            selected_rows = [];
            for (let key in this.rows_selection_status) {
                if (this.rows_selection_status[key]) {
                    selected_rows.push(key);
                }
            }
        }
        if (selected_rows.length < 1) {
            this.notification.openError('No record selected');
        } else {
            this.push_data_to_client(selected_rows, exporterType, clientExporterName);
            const row_count = selected_rows.length;
            if (clientExporterName?.includes('credit')) {
                this.notification.openSuccess(`${row_count} of ${selected_rows.length} Sales order reversal(s) received and will be processed shortly.`);
            } else {
                this.notification.openSuccess(`${row_count} of ${selected_rows.length} Sales order(s) received and will be processed shortly.`);
            }
        }
    }

    getConstantPropertyComponentTypes(componentTypeId: ModelID, constantPropertyIds: ModelID[] = [], autoConditions: ModelID[] = []) {
        this.limits_map = {};
        this.cp_class_dict = {};
        const options = new SearchQueryOptions();
        options.filters = [
            getRelationWithIdFilter('component_type', componentTypeId)
        ];
        if (constantPropertyIds && constantPropertyIds.length > 0) {
            options.filters.push(getRelationWithManyIdsFilter('constant_property', constantPropertyIds));
        }
        return this.api.constant_property_component_type.searchMany(options).pipe(
            first(), takeUntil(this.onDestroy),
            tap(response => {
                    this.constant_property_component_types = response.data;
                    this.constant_property_component_types.map(
                        cpct => {
                            this.limits_map[cpct.relationships.constant_property.data.id] = cpct;
                        }
                    );
                    this.components.forEach(component => {
                        for (let cpId of constantPropertyIds) {
                            if (!this.doFormatting && !this.autoFormattingIds.includes(cpId)) continue;
                            const cp = this.cp_dict[cpId];
                            if (this.generic_constants[component.id]?.hasOwnProperty(cpId) &&
                                isConstant(this.generic_constants[component.id][cpId])) {
                                this.componentEventsTableService.getConstantConditionalFormat(
                                    component.id, this.cp_class_dict, cp, this.selected_cols_dict[cpId], this.limits_map,
                                    (this.generic_constants[component.id][cpId] as ConstantField).value, false);
                            }
                        }
                    });
                }
            )
        )
    }

    updateComponentConstantCalculations() {
        const allSelectedComponentIds = Object.entries(this.rows_selection_status)
            .filter(([k, v]) => v)
            .map(([k, v]) => k);
        this.notification.openInfo(`Starting update of calculations linked to ${allSelectedComponentIds.length} component(s).`);

        if (allSelectedComponentIds.length) {
            const constantPropertyIds = getPropertyIds(this.config.selected_cols.component_type);
            this.componentEventsTableService.updateComponentConstantCalculations(allSelectedComponentIds, constantPropertyIds).subscribe((response) => {
                if (response.warning) {
                    this.notification.openWarning(response.message);
                } else {
                    this.notification.openSuccess(response.message);
                }
                this.refreshComponents();
            });
        } else {
            this.notification.openError("No rows selected.", NOTIFICATION_DURATION_MS);
        }
        this.checkComponentConstantCalculationsStatusPoll();
    }

    openEdit() {
        this.needToEdit.emit('Query Builder');
    }

    doQueryWarning() {
        if (!(this.config.query || this.config.constant_property_time)) {
            return;
        }
        // reset warning class
        this.buttons.find(btn => btn.name === 'Query Used').class =
            this.buttons.find(btn => btn.name === 'Query Used').class.replaceAll(' warning', '');

        this.buttons.find(btn => btn.name === 'Query Used').HoverOverHint =
            this.componentEventsTableService.getQueryWarningTooltip(this.config, this.cp_dict);

        if (this.components?.length < 1) {
            this.buttons.find(btn => btn.name === 'Query Used').class += ' warning';
        }

    }

    lockData($event) {
        if (this.components?.length < 1) {
            return;
        }

        const selectedComponents = Object.keys(this.rows_selection_status).filter(item => this.rows_selection_status[item] === true);

        if (this.componentEventsTableService.shouldUseUpdatedFiltering(this.config)) {
            const filters = this.componentEventsTableService.getComponentsFilterNonDate(
                this.config, this.dateInst.dtp, this.search_by_name,
                this.user_filters, this.query_builder_filters);
            // A004: abort on empty-array sentinel (search_by_name required but blank).
            if (this.componentEventsTableService.isNameSearchAbortSentinel(filters)) {
                return;
            }

            if (selectedComponents.length > 0) {
                // Rows are already selected - pass them directly as model_ids.
                this.lockDataService.lockData('component', this.config.lock_template.id,
                    selectedComponents.length, undefined, selectedComponents, this.component_type.attributes.name);
            } else {
                // Pass constant_date_filter to the backend - the /api/lockdown endpoint now
                // handles server-side date-range filtering, eliminating the pre-resolve round-trip.
                const constantDateFilter = ComponentEventsTableService.buildConstantDateFilter(this.config, this.dateInst.dtp);
                this.lockDataService.lockData('component', this.config.lock_template.id,
                    this.component_total, filters, undefined, this.component_type.attributes.name,
                    JSON.stringify(constantDateFilter));
            }
        } else {
            const filters = this.componentEventsTableService.getComponentsFilter(this.config, this.dateInst.dtp,
                this.search_by_name, this.user_filters, this.query_builder_filters);
            this.lockDataService.lockData('component', this.config.lock_template.id, this.component_total, filters, selectedComponents, this.component_type.attributes.name);
        }
    }

    setButtons(): void {
        this.buttons = [
            {
                name: 'Generate PDF Portrait',
                func: () => this.exportToPdf('portrait'),
                class: 'fa small fa-file-pdf-o hide-xs',
                HoverOverHint: 'Generate portrait pdf for the tile'
            },
            {
                name: 'Generate PDF Landscape',
                func: () => this.exportToPdf('landscape'),
                class: 'fa small fa-file-pdf-o hide-xs',
                HoverOverHint: 'Generate landscape pdf for the tile'
            },
            {
                name: 'Download Data',
                func: ($event) => this.getEventDataFileType($event),
                class: 'small fas fa-file-download hide-xs',
                HoverOverHint: 'Download table data as a .csv or .xlsx file',
                disabled: this.isDownloading
            }
        ];

        if (this.config.lock_template?.id) {
            if (["create event_lock", 'create component_lock', 'create lock_template_version']
                .every(f => this.appScope.current_user.feature_names.includes(f))) {
                this.buttons.push(
                    {
                        name: 'Lock Data',
                        func: ($event) => this.lockData($event),
                        class: 'small fas fa-lock hide-xs',
                        HoverOverHint: 'Lock data with the selected template'
                    }
                );
            }
        }
        if (this.config.enable_export_component?.length > 0) {
            this.config.enable_export_component.forEach(item => {
                if (item.supports_bulk_export === true) {
                    this.buttons.push(
                        {
                            name: item.display_text || camelLabel(item.export_name),
                            func: () => this.push_selected_components_to_client(item),
                            class: 'fa small fa-arrow-up',
                            HoverOverHint: item.display_text
                        },
                    );
                }
            });
        }

        if (this.config.enable_row_selection) {
            this.buttons.push(
                {
                    name: 'Update Calculations',
                    func: () => this.updateComponentConstantCalculations(),
                    class: 'fa small fa-repeat hide-xs',
                    HoverOverHint: 'Manually re-run component calculations'
                },
            );
        }

        this.buttons.push(
            {
                name: this.rblTriggerInProgress ? 'Queueing Auto Linking...' : 'Run Auto Linking',
                func: () => this.runAutomaticLinkingForCurrentComponentType(),
                class: 'fa small fa-link hide-xs',
                HoverOverHint: 'Queue rule-based linking for this component type',
                disabled: this.rblTriggerInProgress
                    || !this.component_type?.id
                    || !this.userService.canRunAutoLinking()
                    || !this.hasAutoLinkingRules
            }
        );

        if (this.config.query || (this.config.constant_property_time && (this.config.start_prop || this.config.end_prop))) {
            this.buttons.push({
                name: 'Query Used',
                func: () => this.openEdit(),
                class: 'small fas fa-info-circle hide-xs',
                HoverOverHint: 'This table is using a custom query. Click to open the query builder.'
            });
        }
        this.tileData.buttonsChanged.next(this.buttons);
    }

    runAutomaticLinkingForCurrentComponentType(): void {
        const componentTypeId = this.component_type?.id;
        if (!componentTypeId || this.rblTriggerInProgress) {
            return;
        }
        this.rblTriggerInProgress = true;
        this.setButtons();
        this.api.runAutomaticComponentLinks({component_type_id: componentTypeId}).subscribe({
            next: () => {
                this.notification.openSuccess("Queued automatic linking run for this component type.");
                this.rblTriggerInProgress = false;
                this.setButtons();
            },
            error: () => {
                this.notification.openError("Failed to queue automatic linking run for this component type.");
                this.rblTriggerInProgress = false;
                this.setButtons();
            }
        });
    }

    private headerLeftLogoDataUrl?: string;
    private headerRightLogoDataUrl?: string;

    async exportToPdf(orientation): Promise<void> {
        const dtp = this.dateInst.dtp;
        let pdfName = this.tileData?.tile?.attributes?.title;
        if (!pdfName) {
            pdfName = this.headerData.title;
        } else {
            if (this.headerData.title) {
                pdfName = utils.deepCopy(this.headerData.title).concat("_", pdfName);
            }
        }
        const docTitle: string = utils.printDocTitle(pdfName, dtp.start, dtp.end);
        const data = (this.dataSource as any).data || this.dataSource;
        const rightLogoUrl = this.headerData.rightLogoUrl();

        if (!this.headerLeftLogoDataUrl) {
            this.headerLeftLogoDataUrl = await this.pdfExport.loadImageFromDomAsPngDataUrl(rightLogoUrl, RIGHT_LOGO_MMS_URL);
        }
        if (!this.headerRightLogoDataUrl) {
            this.headerRightLogoDataUrl = await this.pdfExport.loadImageAsDataUrl(LOGIN_LOGO_URL, RIGHT_LOGO_MMS_URL);
        }
        const columnCount = this.columns.filter(c =>
            !['Select', 'Expand', 'expandedDetail'].includes(c)
        )?.length;

        await this.pdfExport.exportComponentEventsTableToPdf({
            docTitle,
            columns: this.columns,
            data,
            selectedColsDict: this.selected_cols_dict,
            attributeCols: this.attribute_cols,
            cpDict: this.cp_dict,
            ctDict: this.ctDict,
            genericConstants: this.generic_constants,
            componentComponentDict: this.componentComponentDict,
            formats: this.formats,
            tileTitle: this.tileData?.tile?.attributes?.title,
            pageOrientation: orientation,
            maxColsPerPage: orientation === 'portrait' ? columnCount > this.pdfExport.maxAutoColumnsPortrait ?
                    this.pdfExport.maxAutoColumnsPortrait : columnCount :
                columnCount > this.pdfExport.maxAutoColumnsLandscape ? this.pdfExport.maxAutoColumnsLandscape : columnCount,
            headerLeftImage: this.headerLeftLogoDataUrl,
            headerRightImage: this.headerRightLogoDataUrl,
            createdBy: this.appScope.current_user.name,
            createdAt: new Date(),
        }, this.dtp);
    }

    setFilterTableButtonConfig() {
        this.filter_button_config = {
            cp_dict: this.cp_dict,
            constant_properties: this.constant_properties.filter(cp => getPropertyIds(this.config.selected_cols.component_type).includes(cp.id)),
            component_type: this.component_type,
            component_types: this.componentTypes,
            column_dict: this.selected_cols_dict,
            time_properties: [this.cp_dict[this.config.start_prop], this.cp_dict[this.config.end_prop]]
        };
    }

    mimicScrollBottom(event) {
        if (!this.config.scroll_top || !this.component_events_table?.nativeElement) {
            return;
        }
        this.component_events_table.nativeElement.scrollLeft = event.target.scrollLeft;
    }

    mimicScrollTop(event) {
        if (!this.config.scroll_top || !this.top_scroll?.nativeElement) {
            return;
        }
        this.top_scroll.nativeElement.parentElement.scrollLeft = event.target.scrollLeft;
    }

    setTopScroll() {
        if (!this.config.scroll_top || !this.component_events_table?.nativeElement || !this.top_scroll?.nativeElement) {
            return;
        }
        const e = this.component_events_table.nativeElement;
        const width = e.scrollWidth + (e.offsetWidth - e.clientWidth);
        if (width) {
            this.renderer.setStyle(this.top_scroll.nativeElement, 'width', width + 'px');
        }
    }

    setTableHeight() {
        const elRef = this.config.scroll_top ? this.component_events_table?.nativeElement : undefined;
        this.table_height = this.tableUtils.setTableHeight(this.utils_bar, elRef);
        this.changeDetectorRef.markForCheck();
    }

    updateFilterQuery(filters): void {
        this.query_builder_filters = filters;
        this.page_index = 0;
        this.paginator.pageIndex = 0;
        this.refreshComponents();
    }

    public checkComponentConstantCalculationsStatusPoll(): void {
        if (this.config.show_calc_update_status) {
            // Check if there are Dirty Models and poll the API if there are.
            this._calculationCurrentlyUpdatingSubscription =
                this.calcGraphStatusService.startPolling().subscribe((response: ConstantCalculationsStatusResponse) => {
                    this.buttons = this.tableUtils.refreshCalculationStatus(this.buttons, response);
                    this.headerData.hidePageLoader = response.is_updating;
                    if (!response.is_updating) {
                        this._calculationCurrentlyUpdatingSubscription.unsubscribe();
                    }
                });
        }
    }

    protected readonly TOOLTIP_SHOW_DELAY = TOOLTIP_SHOW_DELAY;

    protected readonly deepCopy = deepCopy;
}
